
import { userAgent } from '@/assets/ts/util';
import { UserCenter } from '@/service';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'LaunchWeapp',
    components: {},
})
export default class LaunchWeapp extends Vue {

    public canILaunch: boolean = false;

    public init() {
        const UA = navigator.userAgent;

        const checkVersion = (version: string, baseVersion: string) => {
            try {
                const [first, second = 0, third = 0] = version.split('.');
                const [f, s, t] = baseVersion.split('.');
                if (Number(first) > Number(f)) {
                    return true;
                } else if (Number(first) === Number(f)) {
                    if (Number(second) > Number(s)) {
                        return true;
                    } else if (Number(second) === Number(s)) {
                        return Number(third) >= Number(t);
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } catch (err) {
                console.warn('checkVersion Error:', err);
                return false;
            }
        };

        const checkOS = () => {
            const android = UA.match(/Android \d+(\.\d+\.\d+)?/)?.[0].replace('Android ', '');
            const ios = UA.match(/OS \d+_\d+ like Mac OS X/)?.[0]
                .replace('OS ', '')
                .replace(' like Mac OS X', '')
                .replace('_', '.');
            if (android) {
                return checkVersion(android, '5.0.0');
            }
            if (ios) {
                return checkVersion(ios + '.0', '10.3.0');
            }
            return false;
        };

        switch (userAgent()) {
            case 'Wechat':
                const v = UA.match(/MicroMessenger\/\d+\.\d+\.\d+/)?.[0].replace('MicroMessenger/', '');
                if (!v) {
                    this.canILaunch = false;
                    break;
                }
                this.canILaunch = checkVersion(v, '7.0.12') && checkOS();
                break;
            default:
                this.canILaunch = false;
                break;
        }
    }

    private ready(e: any) {
        console.log('ready', e);
    }

    private launch(e: any) {
        console.log('launch', e);
    }

    private error(e: any) {
        console.log('error', e);
        this.canILaunch = false;
    }

    private async config() {
        switch (userAgent()) {
            case 'Wechat':
                try {
                    const { data } = await UserCenter.JSSDKConfig();
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                        appId: window.SERVER_CONFIG.APPID, // 必填，公众号的唯一标识
                        timestamp: data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: data.noncestr, // 必填，生成签名的随机串
                        signature: data.sign, // 必填，签名
                        jsApiList: ['getLocation'], /** 必填，需要使用的JS接口列表，@important 至少填一项否则不授权，包括开放标签 */
                        openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
                    });
                } catch (error) {
                    console.warn(error);
                }
                break;
        }
    }

    private created() {
        this.init();
        this.config();
    }

    private mounted() {
        document.addEventListener('WeixinOpenTagsError', (e: any) => {
            console.error('开放标签加载失败', e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开发标签，JS-SDK其他功能不受影响
        });
    }
}
